
import React from "react";
// react library for routing
import { Link } from "react-router-dom";

// reactstrap components
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useTranslation } from '../../i18n/context';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' }
];

function AdminNavbar() {
  const { t } = useTranslation();
  const { locale, changeLanguage } = useTranslation();
  return (
    <>
      <Navbar
        className="navbar-horizontal navbar-main navbar-dark bg-info"
        expand="lg"
        id="navbar-main"
      >
        <Container>
          <NavbarBrand to="/" tag={Link}>
            <img
              alt="aloPay"
              src={require("assets/img/brand/alo pay 2.png")}
              style={{ height: "65px" }}
            />
          </NavbarBrand>
          <button
            aria-controls="navbar-collapse"
            aria-expanded={false}
            aria-label="Toggle navigation"
            className="navbar-toggler"
            data-target="#navbar-collapse"
            data-toggle="collapse"
            id="navbar-collapse"
            type="button"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <UncontrolledCollapse
            className="navbar-custom-collapse"
            navbar
            toggler="#navbar-collapse"
          >
            <div className="navbar-collapse-header">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/admin/dashboard">
                    <img alt="logo" src={require("assets/img/brand/alo pay 1 (1).png")} />
                  </Link>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button
                    aria-controls="navbar-collapse"
                    aria-expanded={false}
                    aria-label="Toggle navigation"
                    className="navbar-toggler"
                    data-target="#navbar-collapse"
                    data-toggle="collapse"
                    id="navbar-collapse"
                    type="button"
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className="mr-auto" navbar>

            </Nav>
            <Nav className="align-items-lg-center ml-lg-auto" navbar>
              <NavItem className="d-flex align-items-center">
                {languages.map(({ code, flag }) => (
                  <NavLink
                    key={code}
                    className={`nav-link-icon px-2 ${locale === code ? 'active font-weight-bold' : ''}`}
                    onClick={() => changeLanguage(code)}
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="text-lg">{flag}</span>
                  </NavLink>
                ))}
              </NavItem>
              <NavItem className="d-lg-block ml-lg-4">
                <button
                  className="btn btn-neutral btn-icon px-4 py-2"
                  style={{
                    borderRadius: '50px',
                    border: '1px solid #ccc',
                    background: 'transparent',
                    transition: 'all 0.2s ease'
                  }}
                  onClick={() => window.location.href = '/auth/login'}
                >
                  <i className="fas fa-right-to-bracket mr-2" />
                  <span style={{ color: '#bc9b9b' }}>{t('common.login')}</span>
                </button>
              </NavItem>
            </Nav>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
